exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".alert {\n  padding: 20px 40px;\n  font-size: 15px;\n  background: #2daf42;\n  color: white;\n  min-width: 420px;\n  position: fixed;\n  border-radius: 4px;\n  right: 0;\n  top: 10px;\n  margin-right: 20px; }\n\n.alert-error {\n  color: white;\n  font-size: 15px;\n  background: #dd4e4e;\n  padding: 20px 40px;\n  min-width: 420px;\n  position: fixed;\n  border-radius: 4px;\n  right: 0;\n  top: 10px;\n  margin-right: 20px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/caixa/tipo-caixa/tipo-caixa.component.scss
// module id = ../../../../../src/app/components/caixa/tipo-caixa/tipo-caixa.component.scss
// module chunks = main